/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createBookmark.defs.js'
export * as $defs from './createBookmark.defs.js'
